import { Checkbox, CircularProgress, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { debounce } from 'lodash';
import { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { DEBOUNCE_DELAY_MS } from '../../../../constants';
import { getAllUsers } from '../../../../services/apiService';
import { getFullName } from '../../../../utils';

export default function SelectStudent({
  selectedStudent,
  setSelectedStudent,
  deductCredits,
  setDeductCredits,
}) {
  const [studentOptions, setStudentOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [input, setInput] = useState('');

  const handleSearching = async (input) => {
    setIsLoading(true);
    try {
      setStudentOptions([]);
      const response = await getAllUsers({ query: input, limit: 25 });
      if (response?.users?.length) setStudentOptions(response.users);
    } catch (err) {
      console.error(err);
      toast.error('Candidate search failed');
    }
    setIsLoading(false);
  };

  const debounceSearch = useCallback(
    debounce(handleSearching, DEBOUNCE_DELAY_MS),
    []
  );

  useEffect(() => {
    if (!input) {
      setStudentOptions([]);
    } else if (!selectedStudent && input.length >= 2) {
      debounceSearch(input);
    }
  }, [input]);

  return (
    <div className='mt-8 max-w-2xl'>
      <Autocomplete
        options={studentOptions}
        getOptionLabel={(option) => `${getFullName(option)} (${option.email})`}
        onChange={(_, value) => setSelectedStudent(value)}
        value={selectedStudent}
        onInputChange={(_, value) => setInput(value)}
        inputValue={input}
        loading={isLoading}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Student'
            variant='outlined'
            placeholder='Search for student'
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <span className='opacity-60 mx-2'>
                  <Search />
                </span>
              ),
              endAdornment: (
                <>
                  {isLoading && <CircularProgress color='inherit' size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      <div className='flex items-center gap-2 mt-2'>
        <Checkbox
          checked={deductCredits}
          onClick={() => setDeductCredits(!deductCredits)}
          color='primary'
        />
        <span className='opacity-60'>Deduct credits from student account</span>
      </div>
    </div>
  );
}
